<template>
  <div
    v-if="hasMessages"
    class="alert !bg-blue-custom-3 shadow-sm justify-center font-bold mb-3 lg:mb-4 p-3 lg:p-4 lg:flex items-center transition-all duration-700 text-sm md:text-base"
  >
    <transition name="fade" mode="out-in">
      <span :key="currentText" class="inline-flex" v-html="currentText">
      </span>
    </transition>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, watch, computed } from 'vue'

const props = defineProps({
  messages: {
    type: Array,
    default: () => [],
  },
  interval: {
    type: Number,
    default: 4000,
  },
})

const currentIndex = ref(0)
const currentText = ref(props.messages.length ? props.messages[0] : '')
const hasMessages = computed(() => props.messages && props.messages.length > 0)

let timer = null

onMounted(() => {
  if (!hasMessages.value) return

  currentText.value = props.messages[0]
  timer = setInterval(() => {
    currentIndex.value = (currentIndex.value + 1) % props.messages.length
    currentText.value = props.messages[currentIndex.value]
  }, props.interval)
})

watch(
  () => props.messages,
  (newVal) => {
    clearInterval(timer)
    if (newVal.length > 0) {
      currentIndex.value = 0
      currentText.value = newVal[0]
      timer = setInterval(() => {
        currentIndex.value = (currentIndex.value + 1) % newVal.length
        currentText.value = newVal[currentIndex.value]
      }, props.interval)
    } else {
      currentText.value = ''
    }
  },
  { deep: true }
)

onUnmounted(() => clearInterval(timer))
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}
.fade-enter-from {
  opacity: 0;
  transform: translateY(10px);
}
.fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style>
